import React, { useState } from 'react'
import { Button, Textarea } from '@ow/comps'

const USER_TEXT_REG = /\n(\n)*( )*(\n)*\n/g
const dealData = (content) => {
  const str = content
    .replace(USER_TEXT_REG, '\n')
    .split('\n')
    .map((v) => {
      return v.replace(/\s+/g, '')
    })
    .filter((v) => v.length > 0)
  return str.map((v, index) => {
    const obj = v.split(/[,，]/)
    obj.length = 6
    return {
      index,
      name: obj[0],
      username: obj[1] ? obj[1] : '',
      mobile: obj[2],
      password: obj[3],
      repeatpwd: obj[4],
    }
  })
}
const InputUser = function ({ inputDone, gotoBack }) {
  const [textContent, setTextContent] = useState()

  return (
    <>
      <Textarea
        className="w-full mt-2"
        style={{
          paddingLeft: '0.75rem',
          paddingRight: '0.75rem',
          fontSize: '0.8125rem',
        }}
        rows={10}
        value={textContent}
        placeholder="用户姓名1，用户名1，手机号1，登录密码1，重复密码1&#10;用户姓名2，用户名2，手机号2，登录密码2，重复密码2"
        onChange={(e) => {
          setTextContent(e.target.value)
        }}
      />
      <div className="w-full flex flex-row justify-end">
        <Button
          className="mr-2"
          type="primary"
          onClick={() => {
            const data = dealData(textContent)
            inputDone(data)
          }}
          disabled={!textContent || textContent.trim() === ''}
        >
          确定
        </Button>
        <Button
          stroke
          onClick={() => {
            gotoBack()
            setTextContent()
          }}
        >
          取消
        </Button>
      </div>
    </>
  )
}

export default InputUser
